import { api } from './api.js';
import { config } from '../../config/client.js';

export async function enhanceQuery(userQuery) {
  try {
    console.log("Enhancing query:", userQuery);
    const response = await api.post(`/api/enhance-query`, { query: userQuery });
    const enhancedQuery = response.data.enhancedQuery;
    console.log("Enhanced query received: ", enhancedQuery);
    
    return enhancedQuery;
  } catch (error) {
    console.error("Error enhancing query:", error);
    throw error;
  }
}

export async function enhanceQueryWithContext(query, parentQuery, previousAnswer) {
  try {
    console.log('Sending request to enhance query:', {
      query,
      parentQuery,
      previousAnswer
    });

    const response = await api.post(`/api/enhance-query-with-context`, {
      query,
      parentQuery,
      previousAnswer
    });
    
    console.log('Enhanced query response:', response.data);
    
    // Return the full object from the server
    return response.data; // Contains { enhancedQuery, usageData }
  } catch (error) {
    console.error("Error enhancing query with context: ", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    
    // Rethrow with more context
    throw new Error(`Failed to enhance query: ${error.response?.data?.details || error.message}`);
  }
}

export async function summarizeText(text, query) {
  try {
    console.log("Summarizing text:", text);
    const response = await api.post(`/summarize-text`, { text, context: query });
    return response.data.summary;
  } catch (error) {
    console.error('Error summarizing text:', error);
    throw error;
  }
}

export async function generateHistoryTitle(userQuery) {
  try {
    const response = await api.post(`/api/generate-history-title`, { userQuery });
    // Return the full object from the server
    return response.data; // Contains { historyTitle, usageData }
  } catch (error) {
    console.error('Error generating history title:', error);
    throw error;
  }
}

export async function generateBasicAnswer(pageData, query, context = null) {
  try {
    console.log("Sending query to server:", query);
    const endpoint = context ? '/api/generate-basic-answer-with-context' : '/api/generate-basic-answer';
    const payload = { pageData, query, context };
    const response = await api.post(endpoint, payload);
    
    // Return the full object from the server
    return response.data; // Contains { fullAnswer, usageData }
  } catch (error) {
    console.error("Error generating full answer:", error);
    throw error;
  }
}

export async function generateAdvancedAnswer(pageData, query, context = null) {
  try {
    console.log("Sending advanced query to server:", query);
    const endpoint = context ? '/api/generate-advanced-answer-with-context' : '/api/generate-advanced-answer';
    const payload = { pageData, query, context };
    const response = await api.post(endpoint, payload);
    
    // Return the full object from the server
    return response.data; // Contains { fullAnswer, usageData }
  } catch (error) {
    console.error("Error generating advanced answer:", error);
    throw error;
  }
}

export async function generateProAnswer(pageData, query, context = null) {
  try {
    console.log("Sending pro query to server:", query);
    const endpoint = context ? '/api/generate-pro-answer-with-context' : '/api/generate-pro-answer';
    const payload = { pageData, query, context };
    const response = await api.post(endpoint, payload);
    
    // Return the full object from the server
    return response.data; // Contains { fullAnswer, usageData }
  } catch (error) {
    console.error("Error generating pro answer:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      headers: error.response?.headers
    });
    throw error;
  }
}